<template>
  <BaseCard
    title="Reporting Preferences"
    :step-component="'ReportingPreferencesStep'"
  >
    <v-row>
      <v-col cols="12" class="pb-0">
        Receive Reports Via: {{ reportTypes }}
      </v-col>
      <v-col cols="12" class="pb-0" v-if="reportLayouts.length">
        Report Layouts: {{ reportLayouts }}
      </v-col>
      <v-col v-if="!user?.is_copy_to" cols="12" class="pb-0">
        Language:
        {{ getById("locales", selectedClient.locale_code, "code").name }}
      </v-col>
      <v-col v-if="!user?.is_copy_to" cols="12" class="pb-0">
        Units: {{ getById("unit_types", selectedClient.unit_type_id).name }}
      </v-col>
      <v-col v-if="!user?.is_copy_to" cols="12" class="pb-0">
        Hold Report for Entire Package:
        {{ selectedClient.release_full_package ? "Yes" : "No" }}
      </v-col>
      <v-col v-if="!user?.is_copy_to" cols="12" class="pb-0">
        Merge Reports by Farm Name:
        {{ selectedClient.merge_reports_by_farm ? "Yes" : "No" }}
      </v-col>
      <v-col
        cols="12"
        class="pb-0"
        v-if="reportTemplates.length && !user?.is_copy_to"
      >
        Reports: {{ reportTemplates }}
      </v-col>
      <v-col cols="12" v-if="reportTemplateTypes.length && !user?.is_copy_to">
        Specialty Reports: {{ reportTemplateTypes }}
      </v-col>
    </v-row>
  </BaseCard>
</template>

<script>
import BaseCard from "@/components/registration/ReviewStepCards/BaseCard";
import { mapGetters, mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "ReportingPreferences",
  components: { BaseCard },
  computed: {
    ...mapState("clients", [
      "report_communication_types_selected",
      "report_layouts_selected",
      "report_templates_selected",
      "report_template_types_selected"
    ]),
    ...mapState("auth", ["user"]),
    ...mapState("copyTo", [
      "copy_to_communication_types_selected",
      "copy_to_report_layouts_selected"
    ]),
    ...mapState("clients", { clients: "items" }),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapFields("clients", ["client"]),
    ...mapGetters("baseData", ["getById", "report_template_types"]),
    reportTypes() {
      return this.user?.is_copy_to
        ? this.user?.copy_to?.communication_types
            .map(type => type.name)
            .filter(name => !!name)
            .join(", ")
        : this.selectedClient.report_communication_types
            .map(type => type.name)
            .filter(name => !!name)
            .join(", ");
    },
    reportLayouts() {
      const titles = this.report_layouts_selected.map(id => {
        const layout = this.getById("report_layouts", id);
        return layout?.title || null;
      });

      if (titles.some(title => title === null)) {
        return "Loading...";
      }

      return this.user?.is_copy_to
        ? this.user?.copy_to?.report_layouts
            .map(type => type.title)
            .filter(title => !!title)
            .join(", ")
        : titles.join(", ");
    },
    reportTemplates() {
      return (
        this.report_templates_selected
          .reduce((output, type) => {
            output +=
              (this.getById("report_templates", type) || {}).title + ", " || "";
            return output;
          }, "")
          // Trim whitespace
          .trim()
          // Trim commas
          .replace(/(^,)|(,$)/g, "")
      );
    },
    reportTemplateTypes() {
      return (
        this.report_template_types_selected
          .filter(item =>
            this.report_template_types.find(
              report_template_type => report_template_type.id == item
            )
          )
          .reduce((output, type) => {
            output +=
              (this.getById("report_template_types", type) || {}).name + ", " ||
              "";
            return output;
          }, "")
          // Trim whitespace
          .trim()
          // Trim commas
          .replace(/(^,)|(,$)/g, "")
      );
    }
  },
  watch: {
    "selectedClient.report_communication_types": {
      immediate: true,
      handler(newVal) {
        if (!Array.isArray(newVal) || newVal.length === 0) {
          this.reportTypes = "Loading...";
          return;
        }

        this.reportTypes = newVal
          .map(type => type?.name)
          .filter(Boolean)
          .join(", ");
      }
    },
    selectedClient(newVal) {
      this.client = newVal;
      this.report_communication_types_selected = this.selectedClient?.report_communication_types.map(
        item => item.id
      );
    }
  },
  methods: {
    ...mapActions("clients", ["getClients"]),
    ...mapActions("copyTo", ["getCopyToReportPreferences"])
  },
  async mounted() {
    await this.getClients();

    const updatedClient = this.clients.find(
      client => client.id === this.selectedClient?.id
    );
    if (updatedClient) {
      this.client = updatedClient;
    }

    Promise.all([this.getCopyToReportPreferences()]).then(
      () => (this.loading = false)
    );

    this.communication_types_selected = this.user?.copy_to?.communication_types.map(
      c => c.id
    );
    this.report_layouts_selected = this.user?.copy_to?.report_layouts.map(
      r => r.id
    );
  }
};
</script>

<style scoped></style>
